import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Form,
  Input,
  Button,
  Radio,
  Tooltip,
  Typography,
  Row,
  Col,
  Divider,
} from 'antd';
import styles from './explore.module.sass';
import isIP from 'validator/lib/isIP';
import isFQDN from 'validator/lib/isFQDN';
import mixpanel from 'mixpanel-browser';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { STATUS } from '../../../../redux/constants';
import { changeTitle } from '../../../../redux/actions/app';
import {
  showNotification,
  simpleErrorNotification,
} from '../../../../shared-components/Notifications';
import Panel from '../../../../shared-components/Panel';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';

function Explore(props) {
  mixpanel.track('Global Nav - Explore', { location: window.location.href });
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const { Text, Title } = Typography;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const searchInputFieldContent = Form.useWatch('threat_name', form);
  const location = useLocation();
  const q = useQuery();
  const [name, setName] = useState(q.get('name'));
  const [type, setType] = useState(q.get('type'));
  const [selectedAdvancedQuery, setSelectedAdvancedQuery] = useState('any');
  const [selectedAdvancedAnswer, setSelectedAdvancedAnswer] = useState(null);
  const searchInput = useRef(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(props.location.search);
    const IOC_name = searchParams.get('name') || '';
    const type = searchParams.get('type') || '';
    setName(IOC_name);
    setType(type);
    setTimeout(() => {
      searchInput && searchInput.current && searchInput.current.focus();
    }, 100);
  }, [location.key]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.title = 'Explore Indicator DNS Data - Silent Push';
    // eslint-disable-next-line
    props?.loadUser();
    props.loadMySubscriptionPlan();
    props.clearExploreDetails();
    dispatch(changeTitle('Explore Indicator DNS Data', null));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onInputChange = (e) => {
    if (isIP(e.target.value) && !e.target.value?.includes(':')) {
      setSelectedAdvancedQuery('ANYIPV4');
    } else if (isIP(e.target.value) && e.target.value?.includes(':')) {
      setSelectedAdvancedQuery('ANYIPV6');
    } else if (selectedAdvancedQuery === 'ANYIPV4') {
      setSelectedAdvancedQuery('any');
    }
  };

  const onChangeAdvancedQuery = (e) => {
    setSelectedAdvancedQuery(e.target.value);
    setSelectedAdvancedAnswer(null);
  };

  const onChangeAdvancedAnswer = (e) => {
    setSelectedAdvancedAnswer(e.target.value);
    setSelectedAdvancedQuery(null);
  };

  const validateLookupPADNSInput = (data) => {
    //if type is reverse SOA, reverse TXT, MXHASH, NSHASH, SOAHASH or TXTHASH we skip validation

    if (
      selectedAdvancedAnswer === 'SOA' ||
      selectedAdvancedAnswer === 'TXT' ||
      selectedAdvancedAnswer === 'MXHASH' ||
      selectedAdvancedAnswer === 'NSHASH' ||
      selectedAdvancedAnswer === 'SOAHASH' ||
      selectedAdvancedAnswer === 'TXTHASH'
    ) {
      return true;
    } else {
      let sanitizedIPCandidate = data?.replaceAll('*', '');
      const IPwithWildcardRegex = new RegExp(/^[\.0-9]*$/gi);
      if (
        sanitizedIPCandidate.match(IPwithWildcardRegex) &&
        data?.includes('*')
      ) {
        showNotification(
          simpleErrorNotification({
            statusCode: 403,
            message: 'Please enter a valid domain or IP address',
          }),
        );

        // this.setState({ exploreInputState: 'error' });
        return false;
      }

      if (
        !data?.toString()?.startsWith('http://') &&
        !data?.toString()?.startsWith('https://') &&
        data?.includes('/') &&
        !data?.includes('./')
      ) {
        showNotification(
          simpleErrorNotification({
            statusCode: 403,
            message: 'Please enter a valid domain or IP address',
          }),
        );

        // this.setState({ exploreInputState: 'error' });
        return false;
      }

      if (data?.startsWith('*') && data?.endsWith('*')) {
        showNotification(
          simpleErrorNotification({
            statusCode: 601,
            message:
              'Wildcards are supported at the beginning or end of the domain string but not both at once. (Only allowed in case of PADNS lookup)',
          }),
        );

        // this.setState({ exploreInputState: 'error' });
        return;
      }

      //lookup PADNS validation, difference to Enrich validation is
      //wildcard (*) is allowed in PADNS lookup, but not in Enrichment

      //this regex is what we think a valid domain looks like
      const domainRegex = new RegExp(
        /^([a-zA-Z0-9*-]+(\.[a-zA-Z0-9*-]+)+.*)$/gi,
      );
      if (
        data
        //&&
        //!data?.toString()?.startsWith('www') &&
        //!data?.toString()?.startsWith('http') &&
        //!data?.toString()?.startsWith('https') &&
        //!data?.includes('*') &&
        //data?.includes('.') &&
        //!data?.includes('/')
      ) {
        let sanitizedData = data
          ?.replaceAll('[', '')
          ?.replaceAll(']', '')
          ?.trim()
          ?.replaceAll(' ', '')
          ?.replaceAll('./', '.');
        if (sanitizedData?.toString()?.startsWith('http://')) {
          sanitizedData = sanitizedData?.replace('http://', '');
        }
        if (sanitizedData?.toString()?.startsWith('https://')) {
          sanitizedData = sanitizedData?.replace('https://', '');
        }
        if (sanitizedData?.toString()?.startsWith('www')) {
          sanitizedData = sanitizedData?.replace('www.', '');
        }
        // if (isIP(sanitizedData) || sanitizedData.match(domainRegex)) {
        if (
          isIP(sanitizedData) ||
          isFQDN(sanitizedData, { allow_wildcard: true }) ||
          (sanitizedData?.includes('*') && sanitizedData.match(domainRegex)) ||
          data?.toString()?.startsWith('http://') ||
          data?.toString()?.startsWith('https://')
        ) {
          return true;
        } else {
          showNotification(
            simpleErrorNotification({
              statusCode: 403,
              message: 'Please enter a valid domain or IP address.',
            }),
          );
          return false;
        }
      } else {
        showNotification(
          simpleErrorNotification({
            statusCode: 403,
            message: 'Please enter a valid domain or IP address.',
          }),
        );
        return false;
      }
    }
  };

  function renderAdvancedSearchPane() {
    return (
      <Form
        form={form}
        name="explore"
        initialValues={{ threat_type: 'any' }}
        onFinish={(values) => {
          if (form?.getFieldValue('threat_name')) {
            if (!validateLookupPADNSInput(form?.getFieldValue('threat_name'))) {
            } else {
              props.history.push(
                `/explore-result?name=${
                  selectedAdvancedAnswer === 'SOA' ||
                  selectedAdvancedAnswer === 'TXT'
                    ? values?.threat_name
                    : values?.threat_name
                        ?.replaceAll('[', '')
                        ?.replaceAll(']', '')
                        ?.trim()
                        ?.replaceAll(' ', '')
                        ?.replaceAll('./', '.')
                }&queryType=${
                  selectedAdvancedQuery
                    ? 'query'
                    : selectedAdvancedAnswer
                    ? 'answer'
                    : 'query'
                }&type=${
                  selectedAdvancedQuery !== null
                    ? selectedAdvancedQuery
                    : selectedAdvancedAnswer !== null
                    ? selectedAdvancedAnswer
                    : isIP(
                        form
                          ?.getFieldValue('threat_name')
                          ?.replaceAll('[', '')
                          ?.replaceAll(']', '')
                          ?.trim()
                          ?.replaceAll(' ', '')
                          ?.replaceAll('./', '.'),
                      )
                    ? 'ANYIPV4'
                    : 'any'
                }&origin_uid=Explore`,
              );

              mixpanel.track('Explore Advanced Search', {
                ioc_name: values?.threat_name,
                ioc_type: selectedAdvancedQuery
                  ? selectedAdvancedQuery
                  : selectedAdvancedAnswer,
                query_type: selectedAdvancedQuery ? 'query' : 'answer',
              });
            }
          }
        }}
      >
        <Tooltip
          title={
            'Wildcards are supported at the beginning or end of the domain string but not both at once. (Only allowed in case of PADNS Lookup)'
          }
        >
          <Form.Item
            name="threat_name"
            rules={[
              {
                required: true,
                message: 'Please input the domain name or IP!',
              },
            ]}
          >
            <Input
              ref={searchInput}
              maxLength={3000}
              onChange={(e) => onInputChange(e)}
              placeholder="Enter Domain or IP"
            />
          </Form.Item>
        </Tooltip>

        <Text>
          Choose a DNS Query (forward) or Answer (reverse) lookup type to use
          with your specified domain, IP or hash value.
        </Text>
        <Title level={4} className={styles.subTitle}>
          Query
        </Title>

        <Radio.Group
          onChange={(e) => onChangeAdvancedQuery(e)}
          value={selectedAdvancedQuery}
        >
          <Radio role="radio" aria-label={'anyRadio'} value="any">
            Any
          </Radio>
          <Radio value="ANYIPV4">Any (IPv4)</Radio>
          <Radio value="A">A</Radio>
          <Radio value="AAAA">AAAA</Radio>
          <Radio value="CNAME">CNAME</Radio>
          <Radio value="MX">MX</Radio>
          <Radio value="NS">NS</Radio>
          <Radio value="PTR4">PTR4</Radio>
          <Radio value="PTR6">PTR6</Radio>
          <Radio value="TXT">TXT</Radio>
          <Radio value="SOA">SOA</Radio>
          <Radio value="ANYIPV6">Any (IPv6)</Radio>
        </Radio.Group>

        <Title level={4} className="mt-1">
          Answer (Reverse)
        </Title>

        <Radio.Group
          onChange={(e) => onChangeAdvancedAnswer(e)}
          value={selectedAdvancedAnswer}
        >
          <Radio role="radio1" value="A">
            A
          </Radio>
          <Radio value="AAAA">AAAA</Radio>
          <Radio value="PTR4">PTR4</Radio>
          <Radio value="PTR6">PTR6</Radio>
          <Radio value="CNAME">CNAME</Radio>
          <Radio value="MX">MX</Radio>
          <Radio value="NS">NS</Radio>
          <Radio value="TXT">TXT</Radio>
          <Radio value="SOA">SOA</Radio>
          <Radio value="MXHASH">MXHASH</Radio>
          <Radio value="NSHASH">NSHASH</Radio>
          <Radio value="SOAHASH">SOAHASH</Radio>
          <Radio value="TXTHASH">TXTHASH</Radio>
        </Radio.Group>

        <div className={styles.formActions}>
          <Tooltip
            title={
              props.mySubscriptionPlan?.has_access_to_explore ? (
                ''
              ) : (
                <>
                  Explore is not part of this subscription plan. To upgrade your
                  subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              )
            }
          >
            {/* <Link
              to={`/explore-result?name=${searchInputFieldContent
                ?.replaceAll('[', '')
                ?.replaceAll(']', '')
                ?.trim()
                ?.replaceAll(' ', '')
                ?.replaceAll('./', '.')}&queryType=${
                selectedAdvancedQuery
                  ? 'query'
                  : selectedAdvancedAnswer
                  ? 'answer'
                  : 'query'
              }&type=${
                selectedAdvancedQuery !== null
                  ? selectedAdvancedQuery
                  : selectedAdvancedAnswer !== null
                  ? selectedAdvancedAnswer
                  : isIP(
                      searchInputFieldContent
                        ?.replaceAll('[', '')
                        ?.replaceAll(']', '')
                        ?.trim()
                        ?.replaceAll(' ', '')
                        ?.replaceAll('./', '.'),
                    )
                  ? 'ANYIPV4'
                  : 'any'
              }`}
            > */}
            <Button
              disabled={!props.mySubscriptionPlan?.has_access_to_explore}
              role={'button9'}
              type="primary"
              htmlType="submit"
            >
              Lookup PADNS
            </Button>
            {/* </Link> */}
          </Tooltip>

          <Button
            className={styles.clearForm}
            role={'button'}
            type="link"
            onClick={() => {
              setSelectedAdvancedQuery(null);
              setSelectedAdvancedAnswer(null);
            }}
            disabled={
              !props.mySubscriptionPlan?.has_access_to_explore ||
              !(selectedAdvancedQuery || selectedAdvancedAnswer)
            }
          >
            Clear Selection
          </Button>
        </div>
      </Form>
    );
  }

  function renderDomainsOnServerPane() {
    return (
      <Panel bgcolor={'#1C3138'} className={styles.queryPanel}>
        <Title level={4}>Domains Hosted on Server</Title>
        <Text>
          Check which domains are hosted on specific name servers or mail
          servers.
        </Text>

        {props.mySubscriptionPlan
          ?.has_access_to_domains_hosted_on_server_recipe ? (
          <Tooltip
            title={
              props.mySubscriptionPlan
                ?.has_access_to_domains_hosted_on_server_recipe ? (
                ''
              ) : (
                <>
                  Explore is not part of this subscription plan. To upgrade your
                  subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              )
            }
          >
            <Link to={'/explore/domain-on-server'}>
              <Button
                disabled={
                  !props.mySubscriptionPlan
                    ?.has_access_to_domains_hosted_on_server_recipe
                }
                role={'button3'}
                type="primary"
                // onClick={() => props.history.push('/explore/domain-on-server')}
              >
                Select
              </Button>
            </Link>
          </Tooltip>
        ) : (
          <Tooltip
            title={
              <>
                Explore is not part of this subscription plan. To upgrade your
                subscription contact us at{' '}
                <a target="_blank" href="mailto:sales@silentpush.com">
                  sales@silentpush.com
                </a>
                .
              </>
            }
          >
            <Button
              disabled={
                !props.mySubscriptionPlan
                  ?.has_access_to_domains_hosted_on_server_recipe
              }
              role={'button3'}
              type="primary"
            >
              Select
            </Button>
          </Tooltip>
        )}
      </Panel>
    );
  }

  function renderReverseAPane() {
    return (
      <Panel bgcolor={'#1C3138'} className={styles.queryPanel}>
        <Title level={4}>Domains Hosted on IP</Title>
        <Text>Find domains that have pointed to a specific IP address.</Text>
        {props.mySubscriptionPlan?.has_access_to_domains_hosted_on_ip_recipe ? (
          <Tooltip
            title={
              props.mySubscriptionPlan
                ?.has_access_to_domains_hosted_on_ip_recipe ? (
                ''
              ) : (
                <>
                  This recipe is not part of this subscription plan. To upgrade
                  your subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              )
            }
          >
            <Link to={'/explore/reverse-a'}>
              <Button
                disabled={
                  !props.mySubscriptionPlan
                    ?.has_access_to_domains_hosted_on_ip_recipe
                }
                role={'button4'}
                type="primary"
                //onClick={() => props.history.push('/explore/reverse-a')}
              >
                Select
              </Button>
            </Link>
          </Tooltip>
        ) : (
          <Tooltip
            title={
              <>
                Explore is not part of this subscription plan. To upgrade your
                subscription contact us at{' '}
                <a target="_blank" href="mailto:sales@silentpush.com">
                  sales@silentpush.com
                </a>
                .
              </>
            }
          >
            <Button
              disabled={
                !props.mySubscriptionPlan
                  ?.has_access_to_domains_hosted_on_ip_recipe
              }
              role={'button3'}
              type="primary"
            >
              Select
            </Button>
          </Tooltip>
        )}
      </Panel>
    );
  }

  function renderForwardAPane() {
    return (
      <Panel bgcolor={'#1C3138'} className={styles.queryPanel}>
        <Title level={4}>IPs Hosting a Domain</Title>
        <Text>Find IPs that are associated with a specific domain name.</Text>
        {props.mySubscriptionPlan?.has_access_to_ips_hosting_a_domain_recipe ? (
          <Tooltip
            title={
              props.mySubscriptionPlan
                ?.has_access_to_ips_hosting_a_domain_recipe ? (
                ''
              ) : (
                <>
                  This recipe is not part of this subscription plan. To upgrade
                  your subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              )
            }
          >
            <Link to={'/explore/forward-a'}>
              <Button
                disabled={
                  !props.mySubscriptionPlan
                    ?.has_access_to_ips_hosting_a_domain_recipe
                }
                role={'button5'}
                type="primary"
                //onClick={() => props.history.push('/explore/forward-a')}
              >
                Select
              </Button>
            </Link>
          </Tooltip>
        ) : (
          <Tooltip
            title={
              <>
                Explore is not part of this subscription plan. To upgrade your
                subscription contact us at{' '}
                <a target="_blank" href="mailto:sales@silentpush.com">
                  sales@silentpush.com
                </a>
                .
              </>
            }
          >
            <Button
              disabled={
                !props.mySubscriptionPlan
                  ?.has_access_to_ips_hosting_a_domain_recipe
              }
              role={'button3'}
              type="primary"
            >
              Select
            </Button>
          </Tooltip>
        )}
      </Panel>
    );
  }

  function renderSpoofingPane() {
    return (
      <Panel bgcolor={'#1C3138'} className={styles.queryPanel}>
        <Title level={4}>Brand Impersonation</Title>
        <Text>
          {' '}
          Check for Typosquatting of company domains or supply chain domains.
          Exclude company infrastructure from your search using our form.
        </Text>
        <Tooltip
          title={
            props.mySubscriptionPlan
              ?.has_access_to_brand_impersonation_recipe ? (
              ''
            ) : (
              <>
                This recipe is not part of this subscription plan. To upgrade
                your subscription contact us at{' '}
                <a target="_blank" href="mailto:sales@silentpush.com">
                  sales@silentpush.com
                </a>
                .
              </>
            )
          }
        >
          <Button
            disabled={
              !props.mySubscriptionPlan
                ?.has_access_to_brand_impersonation_recipe
            }
            role={'button6'}
            type="primary"
            onClick={() => props.history.push('/explore/brand-impersonation')}
          >
            Select
          </Button>
        </Tooltip>
      </Panel>
    );
  }

  function renderIPDiversityPane() {
    return (
      <Panel bgcolor={'#1C3138'} className={styles.queryPanel}>
        <Title level={4}>IP Diversity of Domain</Title>
        <Text>
          The number of IP addresses a domain or URL has pointed to over time.
        </Text>
        {props.mySubscriptionPlan
          ?.has_access_to_ip_diversity_of_domain_recipe ? (
          <Tooltip
            title={
              props.mySubscriptionPlan
                ?.has_access_to_ip_diversity_of_domain_recipe ? (
                ''
              ) : (
                <>
                  This recipe is not part of this subscription plan. To upgrade
                  your subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              )
            }
          >
            <Link to={'/explore/ip-diversity'}>
              <Button
                disabled={
                  !props.mySubscriptionPlan
                    ?.has_access_to_ip_diversity_of_domain_recipe
                }
                role={'button7'}
                type="primary"
                // onClick={() => props.history.push('/explore/ip-diversity')}
              >
                Select
              </Button>
            </Link>
          </Tooltip>
        ) : (
          <Tooltip
            title={
              <>
                Explore is not part of this subscription plan. To upgrade your
                subscription contact us at{' '}
                <a target="_blank" href="mailto:sales@silentpush.com">
                  sales@silentpush.com
                </a>
                .
              </>
            }
          >
            <Button
              disabled={
                !props.mySubscriptionPlan
                  ?.has_access_to_ip_diversity_of_domain_recipe
              }
              role={'button3'}
              type="primary"
            >
              Select
            </Button>
          </Tooltip>
        )}
      </Panel>
    );
  }

  function renderNameServerChangesPane() {
    return (
      <Panel bgcolor={'#1C3138'} className={styles.queryPanel}>
        <Title level={4}>Domain Name Server Changes</Title>
        <Text>The name server changes over time.</Text>
        {props.mySubscriptionPlan
          ?.has_access_to_domain_name_server_changes_recipe ? (
          <Tooltip
            title={
              props.mySubscriptionPlan
                ?.has_access_to_domain_name_server_changes_recipe ? (
                ''
              ) : (
                <>
                  This recipe is not part of this subscription plan. To upgrade
                  your subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              )
            }
          >
            <Link to={'/explore/ns-changes'}>
              <Button
                disabled={
                  !props.mySubscriptionPlan
                    ?.has_access_to_domain_name_server_changes_recipe
                }
                role={'button8'}
                type="primary"
                onClick={() => props.history.push('/explore/ns-changes')}
              >
                Select
              </Button>
            </Link>
          </Tooltip>
        ) : (
          <Tooltip
            title={
              <>
                Explore is not part of this subscription plan. To upgrade your
                subscription contact us at{' '}
                <a target="_blank" href="mailto:sales@silentpush.com">
                  sales@silentpush.com
                </a>
                .
              </>
            }
          >
            <Button
              disabled={
                !props.mySubscriptionPlan
                  ?.has_access_to_domain_name_server_changes_recipe
              }
              role={'button3'}
              type="primary"
            >
              Select
            </Button>
          </Tooltip>
        )}
      </Panel>
    );
  }

  function renderTXTLookup() {
    return (
      <Panel bgcolor={'#1C3138'} className={styles.queryPanel}>
        <Title level={4}>Domain TXT Records</Title>
        <Text>Find TXT records for a domain.</Text>
        {props.mySubscriptionPlan?.has_access_to_domain_txt_records_recipe ? (
          <Tooltip
            title={
              props.mySubscriptionPlan
                ?.has_access_to_domain_txt_records_recipe ? (
                ''
              ) : (
                <>
                  This recipe is not part of this subscription plan. To upgrade
                  your subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              )
            }
          >
            <Link to={'/explore/domain-txt-records'}>
              <Button
                disabled={
                  !props.mySubscriptionPlan
                    ?.has_access_to_domain_txt_records_recipe
                }
                role={'button11'}
                type="primary"
                //onClick={() => props.history.push('/explore/txt')}
              >
                Select
              </Button>
            </Link>
          </Tooltip>
        ) : (
          <Tooltip
            title={
              <>
                Explore is not part of this subscription plan. To upgrade your
                subscription contact us at{' '}
                <a target="_blank" href="mailto:sales@silentpush.com">
                  sales@silentpush.com
                </a>
                .
              </>
            }
          >
            <Button
              disabled={
                !props.mySubscriptionPlan
                  ?.has_access_to_domain_txt_records_recipe
              }
              role={'button3'}
              type="primary"
            >
              Select
            </Button>
          </Tooltip>
        )}
      </Panel>
    );
  }

  return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
    <Row gutter={24} className={styles.explore}>
      <Col xs={24} xl={10} className={styles.exploreForm}>
        <Title level={4} className={styles.title}>
          Lookup Passive DNS Records
        </Title>
        <Text>
          Specify a domain, IP address, or hash value (MX, TXT, NS or SOA) to
          lookup
        </Text>

        {renderAdvancedSearchPane()}
      </Col>

      <Col xs={0} xl={1}>
        <Divider className={styles.divider} type="vertical" />
      </Col>

      <Col xs={24} xl={13} className={styles.exploreQueries}>
        <Title level={4} className={styles.title}>
          Explore Queries
        </Title>

        <Row>
          <Col xs={24} className={styles.exploreQueryContainer}>
            {renderDomainsOnServerPane()}
            {renderReverseAPane()}
          </Col>
          <Col xs={24} className={styles.exploreQueryContainer}>
            {renderForwardAPane()}
            {renderIPDiversityPane()}
          </Col>
          <Col xs={24} className={styles.exploreQueryContainer}>
            {renderNameServerChangesPane()}
            {renderTXTLookup()}
          </Col>
        </Row>

        {/* {renderSpoofingPane()} */}
        {/* {renderHostingInfrastructureASNsLookup()} */}
        {/* {renderQueryBuilder()} */}
        {/* {renderShadowITPane()} */}
      </Col>

      <VersionCheck parentComponentStatus={STATUS.LOADED} />
    </Row>
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}

export default Explore;
